export function credentialName(item = {}) {
  if (item.display_name) return item.display_name;
  let name = String(item.name || "").trim();
  if (item.kind === "academic" || item.kind === "course") return name;
  name = name.replace(/[（(][^）)]*(?:حسب المصدر|بحسب المصدر|كما ورد في المصدر|كما وردت في المصدر|وفق المصدر|الاسم الوارد في المصدر|مسمى المصدر|المستوى غير محدد في المصدر)[^）)]*[）)]/g, "")
    .replace(/\s*[—–\-،؛:]?\s*(?:حسب المصدر|بحسب المصدر|كما ورد في المصدر|كما وردت في المصدر|وفق المصدر|الاسم الوارد في المصدر|مسمى المصدر|المستوى غير محدد في المصدر)\s*$/, "");
  const stored = String(item.abbreviation || name.match(/\(([A-Za-z][A-Za-z0-9+&./\- ]{1,25})\)/)?.[1] || "").trim();
  const abbreviation = ({ "CET-ELECTRONICS": "CET", "CIPD-FAMILY": "CIPD", "CIPS-FAMILY": "CIPS", "CMMP-FAMILY": "CMMP",
    "CMRP-MARKET": "CMRP", "CSM-CROWD": "CSM", "CPP-PROCUREMENT": "CPP" })[stored] || stored;
  if (abbreviation) {
    const escaped = abbreviation.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    name = name.replace(new RegExp(`\\(\\s*${escaped}\\s*\\)`, "gi"), "")
      .replace(new RegExp(`(?<![A-Za-z0-9])${escaped}(?![A-Za-z0-9])`, "gi"), "");
  }
  name = name.replace(/\s+/g, " ").replace(/^[ —–\-:،؛()]+|[ —–\-:،؛()]+$/g, "");
  return name && abbreviation ? `${name} (${abbreviation})` : name || abbreviation;
}
